import NotesStore from './schema/NotesStore';
import { createStore } from 'satcheljs';

const defaultNotesStore: NotesStore = {
    selectedNoteId: undefined,
    selectedNoteColor: undefined,
};

const getStore = createStore<NotesStore>('NotesStore', defaultNotesStore);

export const notesStore = getStore();
export default getStore;
